import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormInput,
  CFormSelect,
  CFormTextarea,
  CRow,
  CCol,
  CButton,
} from "@coreui/react";
import React, { useState } from "react";

import { Loader } from "src/services/const";
import { successAlert, errorAlert } from "src/utils/Swal";

const UserIdentication = () => {
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    branchName: "",
    bankName: "",
    ifsc: "",
    accountNumber: "",
    creditScore: "",
    aadharNumber: "",
    panNumber: "",
    monthlyExpenses: "",
    income: "",
    bankStatementsImageUrl: null,
    singnatureImageUrl: null,
    passportSizePhoto: null,
    panImageUrl: null,
    aadharImageUrl: null,
    paySlipImageUrl: null,
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    switch (name) {
      case "branchName":
        return value.trim() ? "" : "Branch name is required";
      case "bankName":
        return value.trim() ? "" : "Bank name is required";
      case "ifsc":
        return /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/.test(value)
          ? ""
          : "Invalid IFSC code format (e.g., ABCD0123456)";
      case "accountNumber":
        return /^\d{9,18}$/.test(value)
          ? ""
          : "Account number must be 9-18 digits";
      case "creditScore":
        return value >= 300 && value <= 900
          ? ""
          : "Credit score must be between 300-900";
      case "aadharNumber":
        return /^\d{12}$/.test(value) ? "" : "Aadhar number must be 12 digits";
      case "panNumber":
        return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)
          ? ""
          : "Invalid PAN format (e.g., ABCDE1234F)";
      case "monthlyExpenses":
        return value > 0 ? "" : "Monthly expenses must be positive";
      case "income":
        return value > 0 ? "" : "Income must be positive";
      case "bankStatementsImageUrl":
      case "singnatureImageUrl":
      case "passportSizePhoto":
      case "panImageUrl":
      case "aadharImageUrl":
      case "paySlipImageUrl":
        return value ? "" : "This file is required";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, type === "file" ? files[0] : value),
    }));
  };

  const validateAll = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFileUpload = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, [fieldName]: file }));
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateAll()) {
      errorAlert("Validation Error", "Please fix the highlighted fields.");
      return;
    }

    setLoader(true);
    setTimeout(() => {
      successAlert("Success", "Loan application submitted!");
      setFormData({
        branchName: "",
        bankName: "",
        ifsc: "",
        accountNumber: "",
        creditScore: "",
        aadharNumber: "",
        panNumber: "",
        monthlyExpenses: "",
        income: "",
        bankStatementsImageUrl: null,
        singnatureImageUrl: null,
        passportSizePhoto: null,
        panImageUrl: null,
        aadharImageUrl: null,
        paySlipImageUrl: null,
      });
      setErrors({});
      setLoader(false);
    }, 2000);
  };

  const handleReset = () => {
    setFormData({
      branchName: "",
      bankName: "",
      ifsc: "",
      accountNumber: "",
      creditScore: "",
      aadharNumber: "",
      panNumber: "",
      monthlyExpenses: "",
      income: "",
      bankStatementsImageUrl: null,
      singnatureImageUrl: null,
      passportSizePhoto: null,
      panImageUrl: null,
      aadharImageUrl: null,
      paySlipImageUrl: null,
    });
    setErrors({});
  };

  return (
    <div>
      <CForm onSubmit={handleSubmit}>
        <CRow className="mb-3">
          <CCol md={12}>
            <div className="d-flex justify-content-center pt-5 ">
              <div
                style={{
                  fontSize: "16px",
                  color: "#000",
                  fontWeight: "600",
                }}
              >
                Enter Details: User ID, Bank & Income
              </div>
            </div>
          </CCol>
        </CRow>

        {/* Personal Identification */}
        <CCard className="mb-4">
          <CCardHeader>Personal Identification</CCardHeader>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="aadharNumber"
                  label="Aadhar Number"
                  placeholder="Enter 12-digit Aadhar number"
                  value={formData.aadharNumber}
                  onChange={handleChange}
                  invalid={!!errors.aadharNumber}
                  feedback={errors.aadharNumber}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="panNumber"
                  label="PAN Number"
                  placeholder="Enter PAN (e.g., ABCDE1234F)"
                  value={formData.panNumber}
                  onChange={handleChange}
                  invalid={!!errors.panNumber}
                  feedback={errors.panNumber}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="file"
                  name="aadharImageUrl"
                  label="Aadhar Card Image"
                  onChange={(e) => handleFileUpload(e, "aadharImageUrl")}
                  invalid={!!errors.aadharImageUrl}
                  feedback={errors.aadharImageUrl}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="file"
                  name="panImageUrl"
                  label="PAN Card Image"
                  onChange={(e) => handleFileUpload(e, "panImageUrl")}
                  invalid={!!errors.panImageUrl}
                  feedback={errors.panImageUrl}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="file"
                  name="passportSizePhoto"
                  label="Passport Size Photo"
                  onChange={(e) => handleFileUpload(e, "passportSizePhoto")}
                  invalid={!!errors.passportSizePhoto}
                  feedback={errors.passportSizePhoto}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="file"
                  name="singnatureImageUrl"
                  label="Signature Image"
                  onChange={(e) => handleFileUpload(e, "singnatureImageUrl")}
                  invalid={!!errors.singnatureImageUrl}
                  feedback={errors.singnatureImageUrl}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Bank Details */}
        <CCard className="mb-4">
          <CCardHeader>Bank Details</CCardHeader>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="bankName"
                  label="Bank Name"
                  placeholder="Enter bank name"
                  value={formData.bankName}
                  onChange={handleChange}
                  invalid={!!errors.bankName}
                  feedback={errors.bankName}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="branchName"
                  label="Branch Name"
                  placeholder="Enter branch name"
                  value={formData.branchName}
                  onChange={handleChange}
                  invalid={!!errors.branchName}
                  feedback={errors.branchName}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="ifsc"
                  label="IFSC Code"
                  placeholder="Enter IFSC code (e.g., ABCD0123456)"
                  value={formData.ifsc}
                  onChange={handleChange}
                  invalid={!!errors.ifsc}
                  feedback={errors.ifsc}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="accountNumber"
                  label="Account Number"
                  placeholder="Enter account number"
                  value={formData.accountNumber}
                  onChange={handleChange}
                  invalid={!!errors.accountNumber}
                  feedback={errors.accountNumber}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="number"
                  name="creditScore"
                  label="Credit Score"
                  placeholder="Enter credit score (300-900)"
                  value={formData.creditScore}
                  onChange={handleChange}
                  invalid={!!errors.creditScore}
                  feedback={errors.creditScore}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="file"
                  name="bankStatementsImageUrl"
                  label="Bank Statements"
                  onChange={(e) =>
                    handleFileUpload(e, "bankStatementsImageUrl")
                  }
                  invalid={!!errors.bankStatementsImageUrl}
                  feedback={errors.bankStatementsImageUrl}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Income Details */}
        <CCard className="mb-4">
          <CCardHeader>Income Details</CCardHeader>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="number"
                  name="income"
                  label="Monthly Income (₹)"
                  placeholder="Enter monthly income"
                  value={formData.income}
                  onChange={handleChange}
                  invalid={!!errors.income}
                  feedback={errors.income}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="number"
                  name="monthlyExpenses"
                  label="Monthly Expenses (₹)"
                  placeholder="Enter monthly expenses"
                  value={formData.monthlyExpenses}
                  onChange={handleChange}
                  invalid={!!errors.monthlyExpenses}
                  feedback={errors.monthlyExpenses}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="file"
                  name="paySlipImageUrl"
                  label="Pay Slip"
                  onChange={(e) => handleFileUpload(e, "paySlipImageUrl")}
                  invalid={!!errors.paySlipImageUrl}
                  feedback={errors.paySlipImageUrl}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          <CButton
            type="button"
            onClick={handleReset}
            style={{
              background: "linear-gradient(181deg, #000208, #333)",
              padding: "10px 20px",
            }}
            color="primary"
          >
            Reset
          </CButton>

          {loader ? (
            <Loader />
          ) : (
            <CButton
              style={{
                background: "linear-gradient(181deg, #000208, #333)",
                padding: "10px 20px",
              }}
              type="submit"
              color="primary"
            >
              Submit
            </CButton>
          )}
        </div>
      </CForm>
    </div>
  );
};

export default UserIdentication;
